import { createAPI } from '@common'
export default {
  // 获取上传到云视的accessToken（获取上传凭证）
  postMamMaterialAccesstoken: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0gjmf0qbsu0uplfo', 'POST', config, {
      neverLoading: true
    }),
  // 注册音视频信息
  postMamMaterialRegister: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0vqmpbe0sfhjtufs', 'POST', config),
  // 获取上传到云视的accessToken（获取上传凭证）
  postBase64Upload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0vqmpbe', 'POST', config, {
      neverLoading: true,
      isSimpleSecurity: true
    })
  /* 
  // 获取视频详情
  getMamMaterialVideoDetail: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0w20nbn0nbufsjbm0wjefp0efubjm', 'GET', config, vconfig),
  // 媒资送审（素材库送审）
  postMamMaterialTransfer: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0nbufsjbm0usbotgfs', 'POST', config),
  // 媒资审核通过（素材库审核通过）
  postMamMaterialPass: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0nbufsjbm0qbtt', 'POST', config),
  // 媒资驳回（素材库驳回）
  postMamMaterialReject: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0nbufsjbm0sfkfdu', 'POST', config),
  // 媒资发布（素材库发布）
  postMamMaterialPublish: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0nbufsjbm0qvcmjti', 'POST', config) */
}
